class MobileMenu extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    document.addEventListener('drawerOpen', e => {
      if (e.detail.key === 'mobile') {
        if (this?.externalEls?.scroller) {
          this.externalEls.scroller.element.scrollTop = 0
        }
      }
    })
  }

  setupListeners () {
    if (
      this?.els?.promos &&
      this?.externalEls?.scroller &&
      this?.externalEls?.header
    ) {
      this.toggleLogo = this.toggleLogo.bind(this)

      this.listeners.add(
        this.externalEls.scroller.element,
        'scroll',
        this.toggleLogo,
      )
    }
  }

  toggleLogo () {
    const promosTopPosition = this.els.promos.element.getBoundingClientRect()
      .top

    const headerBottomPosition =
      this.externalEls.header.element.getBoundingClientRect().top +
      this.externalEls.header.element.offsetHeight

    document.body.classList.toggle(
      'util-ShowLogo',
      headerBottomPosition > promosTopPosition,
    )
  }
}

if (!customElements.get('mobile-menu')) {
  customElements.define('mobile-menu', MobileMenu)
}
